<template>
  <div class="layout-main" v-if="!isBusy" :class="{ 'is-open': isSideMenuOpen }">
    <aside class="layout-main__sidebar u-pt">
      <div class="u-ph">
        <img src="@/assets/images/logo.png" alt="SDOS" width="140px" class="">
      </div>
      <side-menu />
    </aside>
    <main class="layout-main__main u-mb-large">
      <div class="layout-main__header">
        <main-header-nav @toggleSideMenu="toggleSideMenu" />
      </div>
      <div class="layout-main__content u-mb">
        <div class="u-bg-secondary u-ph u-pv-huge u-mb-large">
          <a href="" @click.prevent="$router.go(-1)">
            <font-awesome-icon icon="chevron-left" class="u-mr-small" />
            <span>Volver</span>
          </a>
          <h1 class="u-mb-none">{{ user.name }}</h1>
        </div>
        <div class="o-wrapper u-mb-large">
          <user-form :user="user"/>
        </div>
        <div class="o-wrapper">
          <h2 class="u-bb u-pb u-mb-large">Entradas de {{ user.name }}</h2>
          <user-posts-list :posts="user.posts" />
        </div>
      </div>
      <div class="layout-main__overlay" @click="toggleSideMenu"></div>
    </main>
  </div>
</template>

<script>
import MainHeaderNav from '@/components/navs/main-header-nav'
import SideMenu from '@/components/navs/side-menu'
import UserForm from '@/components/forms/user-form'
import UserPostsList from '@/components/lists/userPostsList'

export default {
  name: 'UserEdit',

  components: {
    MainHeaderNav,
    SideMenu,
    UserForm,
    UserPostsList
  },

  props: {
    id: { type: [Number, String], required: true },
  },

  mounted() {
    // try {
    //   this.$store.commit('setIsBusy', true)
    //   if (Object.keys(this.user).length === 0) {
    //     this.fetchUser()
    //   }
    //   this.$store.dispatch('user/fetchUserPosts', this.id)
    // } finally {
    //   this.$store.commit('setIsBusy', false)
    // }
    if (Object.keys(this.user).length === 0 || ! this.user.posts) {
      this.fetchUser()
    }
  },

  data() {
    return {
      isSideMenuOpen: false
    }
  },

  computed: {
    isBusy() {
      return this.$store.state.isBusy
    },

    user() {
      return this.$store.state.user.user
    }
  },

  methods: {
    fetchUser() {
      this.$store.dispatch('user/fetchUser', this.id)
    },

    toggleSideMenu() {
      this.isSideMenuOpen = !this.isSideMenuOpen
    }
  }
}
</script>
